hp6-icon-button {
  height: auto;
  position: relative;
  display: inline-flex;
  align-items: center;

  button {
    /** START | style resets **/
    margin: 0;
    border: none;
    background: none;
    appearance: none;
    /** END | style resets **/
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 var(--spacing-xs);
  }

  > * {
    height: 100%;
    cursor: pointer;

    hp6-icon {
      display: block;
    }
  }

  &[size-selection="sm"] {
    height: var(--button-height-sm);

    button {
      padding: 0 var(--spacing-xs);
      width: 100%;

      .icon {
        margin: auto;
      }
    }
  }

  &[size-selection="md"] {
    height: var(--button-height-md);
    button {
      padding: 0 var(--spacing-xs);
      width: 100%;

      .icon {
        margin: auto;
      }
    }
  }

  &[type-selection="primary"] button {
    background-color: var(--color-link-base);
    border: solid 1px var(--color-neutral-base);

    hp6-icon {
      --system-color: var(--color-text-xlight);
      --brand-color-path-one: var(--color-text-xlight);
      --brand-color-path-two: var(--color-text-xlight);
    }

    &:focus {
      background-color: var(--color-link-dark);
    }

    &:hover {
      background-color: var(--color-link-dark);
    }

    &:active {
      background-color: var(--color-link-xdark);
    }
  }

  &[type-selection="secondary"] button {
    background-color: var(--color-neutral-xxlight);
    border: solid 1px var(--color-neutral-base);

    hp6-icon {
      --system-color: var(--color-link-base);
      --brand-color-path-one: var(--color-link-base);
      --brand-color-path-two: var(--color-link-base);
    }

    &:focus {
      hp6-icon {
        --system-color: var(--color-link-dark);
        --brand-color-path-one: var(--color-link-dark);
        --brand-color-path-two: var(--color-link-dark);
      }
    }

    &:hover {
      hp6-icon {
        --system-color: var(--color-link-dark);
        --brand-color-path-one: var(--color-link-dark);
        --brand-color-path-two: var(--color-link-dark);
      }
    }

    &:active {
      hp6-icon {
        --system-color: var(--color-link-xdark);
        --brand-color-path-one: var(--color-link-xdark);
        --brand-color-path-two: var(--color-link-xdark);
      }
    }
  }

  &[type-selection="floating"] {
    width: var(--button-width);
    button {
      padding: 0;
      background-color: transparent;
      border: none;

      hp6-icon {
        --system-color: var(--color-neutral-dark);
        --brand-color-path-one: var(--color-neutral-dark);
        --brand-color-path-two: var(--color-neutral-dark);
      }

      &:focus {
        hp6-icon {
          --system-color: var(--color-link-dark);
          --brand-color-path-one: var(--color-link-dark);
          --brand-color-path-two: var(--color-link-dark);
        }
      }

      &:hover {
        hp6-icon {
          --system-color: var(--color-link-dark);
          --brand-color-path-one: var(--color-link-dark);
          --brand-color-path-two: var(--color-link-dark);
        }
      }

      &:active {
        hp6-icon {
          --system-color: var(--color-link-xdark);
          --brand-color-path-one: var(--color-link-xdark);
          --brand-color-path-two: var(--color-link-xdark);
        }
      }
    }
  }

  &.inverted {
    &[type-selection="primary"] button {
      background-color: var(--color-neutral-xxlight);
      border: solid 1px var(--color-neutral-base);
      hp6-icon {
        --system-color: var(--color-link-base);
        --brand-color-path-one: var(--color-link-base);
        --brand-color-path-two: var(--color-link-base);
      }

      &:focus {
        hp6-icon {
          --system-color: var(--color-link-dark);
          --brand-color-path-one: var(--color-link-dark);
          --brand-color-path-two: var(--color-link-dark);
        }
      }

      &:hover {
        hp6-icon {
          --system-color: var(--color-link-dark);
          --brand-color-path-one: var(--color-link-dark);
          --brand-color-path-two: var(--color-link-dark);
        }
      }

      &:active {
        hp6-icon {
          --system-color: var(--color-link-xdark);
          --brand-color-path-one: var(--color-link-xdark);
          --brand-color-path-two: var(--color-link-xdark);
        }
      }
    }

    &[type-selection="secondary"] button {
      background-color: transparent;
      border: solid 1px var(--color-neutral-base);

      hp6-icon {
        --system-color: var(--color-neutral-xxlight);
        --brand-color-path-one: var(--color-neutral-xxlight);
        --brand-color-path-two: var(--color-neutral-xxlight);
      }

      &:focus {
        border-color: var(--color-neutral-xlight);
      }

      &:hover {
        border-color: var(--color-neutral-xlight);
      }

      &:active {
        border-color: var(--color-neutral-xxlight);
      }
    }

    &[type-selection="floating"] button {
      padding: 0;
      background-color: transparent;
      border: none;

      hp6-icon {
        --system-color: var(--color-neutral-xxlight);
        --brand-color-path-one: var(--color-neutral-xxlight);
        --brand-color-path-two: var(--color-neutral-xxlight);
      }
    }
  }

  &.rounded button {
    border-radius: 2pt;
  }
}
